import React from 'react';
import { IconProps } from '../IconProps';
const SvgDots = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M13.429 12a1.429 1.429 0 11-2.858 0 1.429 1.429 0 012.858 0zM13.429 5.428a1.429 1.429 0 11-2.858 0 1.429 1.429 0 012.858 0zM13.429 18.573a1.429 1.429 0 11-2.858 0 1.429 1.429 0 012.858 0z"
      fill="#0D0300"
    />
  </svg>
);
export default SvgDots;
